import { Provider } from "@angular/core";
import { NativeTokenStorage } from "./native-token-storage.service";
import { TOKEN_STORAGE } from "./token-storage.interface";
import { WebTokenStorage } from "./web-token-storage.service";

export function provideMobileTokenStorage(): Provider[] {
  return [
    WebTokenStorage,
    NativeTokenStorage,
    {
      provide: TOKEN_STORAGE,
      useFactory: (web: WebTokenStorage, native: NativeTokenStorage) => {
        const isNativeRuntime =
          typeof window !== "undefined" &&
          !!(window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor
            ?.isNativePlatform?.();
        return isNativeRuntime ? native : web;
      },
      deps: [WebTokenStorage, NativeTokenStorage],
    },
  ];
}
